import { render, staticRenderFns } from "./home-parallax.vue?vue&type=template&id=5ebe29be&scoped=true&lang=pug&"
import script from "./home-parallax.vue?vue&type=script&lang=js&"
export * from "./home-parallax.vue?vue&type=script&lang=js&"
import style0 from "./home-parallax.vue?vue&type=style&index=0&id=5ebe29be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe29be",
  null
  
)

export default component.exports